// extracted by mini-css-extract-plugin
export var chevronIcon = "_77-2";
export var teamName = "_77-1";
export var teamSwitcherButton = "_77-0";